import SidebarBookingsRoute from 'uplisting-frontend/pods/-sidebar/bookings/route';

export default class ActionBookingsRoute extends SidebarBookingsRoute {}
